/**
 * ADMIN & TENANCY CONSTANTS
 *
 * Shared so the backend, the admin app and (later) the customer app all agree
 * on the exact role strings. If the backend stores "superadmin" and the UI
 * checks for "super_admin", permission checks silently fail — defining the
 * values ONCE here makes that impossible.
 */

/**
 * The two admin roles.
 *   SUPER_ADMIN — the owner. Manages colleges, admins and all products.
 *   ADMIN       — a college admin. Scoped to exactly ONE college.
 */
export const ADMIN_ROLE = Object.freeze({
  SUPER_ADMIN: 'superadmin',
  ADMIN: 'admin',
});

/** Human-readable labels for the UI. */
export const ADMIN_ROLE_LABEL = Object.freeze({
  [ADMIN_ROLE.SUPER_ADMIN]: 'Super Admin',
  [ADMIN_ROLE.ADMIN]: 'College Admin',
});

/** All valid roles, handy for validation and Mongoose enums. */
export const ADMIN_ROLES = Object.freeze(Object.values(ADMIN_ROLE));

/**
 * Is this role the super admin? A tiny helper, but using it everywhere means
 * the comparison string lives in one place.
 */
export function isSuperAdmin(role) {
  return role === ADMIN_ROLE.SUPER_ADMIN;
}
